import { Avatar, AvatarProps } from 'primereact/avatar'

import { useUserContext } from '../contexts/UserContext'
import { Row } from './pure/FlexContainer'
import TooltipWrapper from './pure/TooltipWrapper'
import User, { generateUserInitials } from '../../models/User'
import { TooltipProps } from 'primereact/tooltip'

interface ProfileAvatarProps extends AvatarProps {
    initials?: string
}

export default function ProfileAvatar({ image, initials, ...props }: ProfileAvatarProps) {
    return (
        <div className="profile-avatar">
            {image ? (
                <Avatar className="profile-avatar__image" image={image} size="large" {...props} />
            ) : (
                <Row alignment="center" arrangement="center" className="profile-avatar__initials">
                    {initials}
                </Row>
            )}
        </div>
    )
}

interface TooltipAvatarProps extends AvatarProps {
    user?: User
    name?: string
    id?: string
    target?: string
    position?: TooltipProps['position']
}

export const TooltipAvatar = ({
    user,
    id,
    name,
    target,
    position,
    ...props
}: TooltipAvatarProps) => {
    const { getUserNameById } = useUserContext()
    const userId = id ?? user?.id ?? ''
    const userName = name ?? user?.name ?? getUserNameById(userId)
    if (!userName) return
    const initials = generateUserInitials(userName)
    if (!target)
        console.warn(
            'TooltipAvatar received no target string and will likely not appear in the correct location. ' +
                'The target string should be unique for every avatar.'
        )
    return (
        <TooltipWrapper label={userName} target={target} position={position}>
            <Avatar {...props} label={initials} />
        </TooltipWrapper>
    )
}
